import { PropsWithChildren, createContext, useRef, useState } from 'react';
import { ModalProps } from './types';
import { ModalContextType } from './types';
import { ModalKit } from '../../components/UI';
import { Box, Button, CircularProgress } from '@mui/material';

export const ModalContext = createContext<ModalContextType>(null);

export const ModalProvider = ({ children }: PropsWithChildren) => {
  const [modalOptions, setModalOptions] = useState<ModalProps>(null);
  const [isLoading, setIsLoading] = useState(false);
  const state = useRef(null);

  const openModal = (data: ModalProps) => {
    setModalOptions(data);
  };

  const closeModal = () => {
    setModalOptions(null);
  };

  const showLoader = () => {
    setIsLoading(true);
  };

  const hideLoader = () => {
    setIsLoading(false);
  };

  const setValue = (data: any) => {
    state.current = data;
  };

  const ModalFooter = () => {
    return (
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        gap={'24px'}
      >
        <Button
          sx={{
            maxWidth: '126px',
            width: '100%',
            fontSize: '14px',
            color: '#655C68',
            lineHeight: '17px',
            borderColor: '#E3DDE6',
          }}
          onClick={closeModal}
          variant='outlined'
        >
          Cancel
        </Button>
        <Button
          sx={{
            background: '#3293DB',
            color: '#fff',
            maxWidth: '126px',
            width: '100%',
            fontSize: '14px',
            lineHeight: '17px',
          }}
          variant='contained'
          onClick={() => modalOptions?.onSubmit?.(state.current)}
          disabled={!!isLoading}
        >
          {!!isLoading ? <CircularProgress size={20} /> : 'Done'}
        </Button>
      </Box>
    );
  };

  return (
    <ModalContext.Provider
      value={{
        openModal,
        closeModal,
        showLoader,
        hideLoader,
        setValue,
      }}
    >
      <ModalKit
        icon={modalOptions?.icon}
        title={modalOptions?.title}
        description={modalOptions?.description}
        open={!!modalOptions}
        handleClose={closeModal}
        footer={!modalOptions?.hideFooter && <ModalFooter />}
      >
        {modalOptions?.body}
      </ModalKit>
      {children}
    </ModalContext.Provider>
  );
};
